// extracted by mini-css-extract-plugin
export var adjacentSlide = "_mq-9";
export var arrowButtonContainer = "_mq-5";
export var arrowButtonIcon = "_mq-6";
export var carouselArrowButton = "_mq-2";
export var carouselElementContainer = "_mq-1";
export var currentSlide = "_mq-8";
export var left = "_mq-3";
export var otherSlide = "_mq-a";
export var productCarouselContainer = "_mq-0";
export var right = "_mq-4";
export var sliderOverflow = "_mq-7";